import React, { useState, useEffect } from 'react';
import styles from '../styles/FilmModal.module.css';


function FilmModal({ isOpen, onClose, movie }) {
  const [trailerData, setTrailerData] = useState(null);

  function getRatingClass(rating) {
    if (rating < 5) {
      return styles['movie-rating-red-bg']; // Apply the red background class
    } else if (rating >= 5 && rating <= 5.9) {
      return styles['movie-rating-orange-bg']; // Apply the yellow background class
    } else if (rating >= 6 && rating < 7) {
      return styles['movie-rating-yellow-bg']; // Apply the yellow background class
    } else {
      return styles['movie-rating-green-bg']; // Apply the green background class
    }
  }

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleDateString('en-US', { month: 'long' });
    const year = date.getFullYear();
    const dayWithSuffix = getDayWithSuffix(day);

    return `${dayWithSuffix} ${month} ${year}`;
  }

  function getDayWithSuffix(day) {
    if (day >= 11 && day <= 13) {
      return `${day}th`;
    }
    switch (day % 10) {
      case 1:
        return `${day}st`;
      case 2:
        return `${day}nd`;
      case 3:
        return `${day}rd`;
      default:
        return `${day}th`;
    }
  }

  useEffect(() => {
    const fetchTrailerData = async () => {
      try {
        if (isOpen && movie.id) {
          const apiKey = '7c0455acfe171480b7ef1aa0472b2429';
          const apiUrl = `https://api.themoviedb.org/3/movie/${movie.id}/videos?api_key=${apiKey}`;

          const response = await fetch(apiUrl);
          const data = await response.json();

          // Check if data has results and find the first official trailer
          if (data.results && data.results.length > 0) {
            const firstOfficialTrailer = data.results.find(
              (video) => video.type === 'Trailer' && video.official === true
            );

            if (firstOfficialTrailer) {
              setTrailerData(firstOfficialTrailer);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching trailer data:', error);
      }
    };

    fetchTrailerData();
  }, [isOpen, movie.id]);

  // Conditionally apply the "open" class to the modal container based on isOpen
  const modalClassName = isOpen ? `${styles['modal-container']} ${styles['open']}` : styles['modal-container'];

  return (
    <div>
      {isOpen && (
        <div className={styles['modal-overlay']}>
          <div className={modalClassName}>
            <button className={styles['close-button']} 
                    onClick={() => {
                            onClose(); // Close the modal
                            setTrailerData(null); // Reset the trailer data
    }}

               
            >
              Close
            </button>
            <div className={styles['modal-content']}>
              <h2 className={styles['movie-title']}>{movie.title}</h2>
              <p className={getRatingClass(movie.vote_average)}>TMDB Rating {movie.vote_average.toFixed(1)}</p>
              <p className={styles['movie-release']}>Release Date: {formatDate(movie.release_date)}</p>
              {trailerData ? (
                <iframe
                  className={styles['movie-trailer']}
                  src={`https://www.youtube.com/embed/${trailerData.key}`}
                  title={trailerData.name}
                  frameBorder="0"
                  allowFullScreen
                ></iframe>
              ) : (
                <img
                  className={styles['movie-poster']}
                  src={`https://image.tmdb.org/t/p/w500${movie.poster_path}`}
                  alt={movie.title}
                />
              )}
              <p className={styles['movie-description']}>{movie.overview}</p>
              {/* Add reviews or additional content here */}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default FilmModal;
